export default {
  plural: 'Twin Parts',
  createButton: 'Create part',
  createTitle: 'Create part',
  editTitle: 'Edit part',
  deleteTitle: 'Delete part',
  deleteWarning: 'Are you sure you want to delete this part?',
  company: 'Company'
};
